import FindConversationResponseMessage from 'owa-service/lib/contract/FindConversationResponseMessage';
import FolderId from 'owa-service/lib/contract/FolderId';
import indexedPageView from 'owa-service/lib/factory/indexedPageView';
import { findConversation } from './findConversation';
import { logLoadedConversationIds } from './utils/logFindMailResponse';
import { tryConsumeFindConversationResponse } from 'mini-session-storage/lib/utils/sessionDataResponseStash';
import type { FindConversationWithStartIndexParams } from '../store/schema/FindConversationWithStartIndexParams';

/**
 * The FindConversationWithStartIndex is used today to load rows when we want to load them from the beginning (or 0th index)
 * This is currently used in load initial rows and in reload scenarios
 */
export default function findConversationWithStartIndex({
    baseFolderId,
    startIndex,
    rowsToLoad,
    shouldTryToUseSessionDataResponse,
    ...remainingParams
}: FindConversationWithStartIndexParams): Promise<FindConversationResponseMessage> {
    if (shouldTryToUseSessionDataResponse) {
        const sessionDataFindConversationResponse = tryConsumeFindConversationResponse(
            (baseFolderId as FolderId).Id,
            startIndex
        );
        if (sessionDataFindConversationResponse) {
            // Return the session data response if available instead of going to the server
            return Promise.resolve(sessionDataFindConversationResponse);
        }
    }

    const paging = indexedPageView({
        BasePoint: 'Beginning',
        Offset: 0 /* startIndex */,
        MaxEntriesReturned: rowsToLoad,
    });

    return findConversation({
        folderId: baseFolderId,
        paging,
        ...remainingParams,
    }).then(logLoadedConversationIds);
}
